// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__20jbW","info":"Note_info__cuZCL","note":"Note_note__1AUA8","actions":"Note_actions__2rLQu"};